export function getTokenFromUrl() {
  return new URLSearchParams(window.location.search).get("token");
}

export function stripTokenFromUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete("token");
  window.history.replaceState({}, document.title, url.pathname + url.search);
}

export function decodeJwtPayload<T = Record<string, any>>(
  token: string,
): T | null {
  try {
    const payload = token.split(".")[1];
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join(""),
    );
    return JSON.parse(json) as T;
  } catch (error) {
    console.warn("Failed to decode JWT payload:", error);
    return null;
  }
}
